export default {"src":"/polygon/_next/static/media/fund_18.67751b25.svg","height":80,"width":231};